import type { ReactElement } from "react";
import styles from "./AppFooter.module.css";

const LINKS: { label: string; href: string }[] = [
  {
    label: "Terms & conditions",
    href: "https://www.propertyfinder.com/terms-and-conditions/#api-access-terms",
  },
  {
    label: "Privacy policy",
    href: "https://www.propertyfinder.com/privacy-policy/",
  },
  {
    label: "Cookie policy",
    href: "https://www.propertyfinder.com/cookie-policy/",
  },
  {
    label: "API terms of use",
    href: "https://www.propertyfinder.com/terms-and-conditions/#api-access-terms",
  },
];

export interface AppFooterProps {
  hidden?: boolean;
}

export function AppFooter({ hidden = false }: AppFooterProps): ReactElement | null {
  if (hidden) return null;
  return (
    <footer className={styles.footer}>
      <span className={styles.copy}>
        &copy; 2026 Property Finder. All rights reserved.
      </span>
      <div className={styles.links}>
        {LINKS.map(({ label, href }) => (
          <a key={label} href={href} target="_blank" rel="noopener noreferrer">
            {label}
          </a>
        ))}
      </div>
    </footer>
  );
}
